<template>
    <g fill="none" fill-rule="evenodd">
        <defs>
            <path id="prefix__a_levelPlayId" d="M0.015 0.012L6.567 0.012 6.567 8.42 0.015 8.42z"/>
            <path id="prefix__c_levelPlayId" d="M0 0.004L5.546 0.004 5.546 8.896 0 8.896z"/>
        </defs>
        <circle cx="10" cy="10" r="9.5" stroke="#C2CDD7"/>
        <g>
            <g transform="translate(4.75 4) translate(3.582 .047)">
                <mask id="prefix__b_levelPlayId" fill="#fff">
                    <use xlink:href="#prefix__a_levelPlayId"/>
                </mask>
                <path fill="#0B6FFF" d="M6.567 4.218c0-2.322-1.882-4.204-4.203-4.204v.008h.03L.015.012l.001 3.039 3.507-.012-1.029 2.59 1.473-.017L2.397 8.42c2.306-.018 4.17-1.892 4.17-4.202" mask="url(#prefix__b_levelPlayId)"/>
            </g>
            <g transform="translate(4.75 4) translate(0 3.092)">
                <mask id="prefix__d_levelPlayId" fill="#fff">
                    <use xlink:href="#prefix__c_levelPlayId"/>
                </mask>
                <path fill="#00CCD7" d="M3.604 3.845L3.604 0.004 3.59 0.004 0 0.008 3.58 8.896 5.546 3.845z" mask="url(#prefix__d_levelPlayId)"/>
            </g>
        </g>
    </g>
</template>

<script>
export default {
    name: 'levelPlayIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 20 20');
    }
};
</script>
